import { render, staticRenderFns } from "./Game.vue?vue&type=template&id=de724fe2&scoped=true&"
import script from "./Game.vue?vue&type=script&lang=ts&"
export * from "./Game.vue?vue&type=script&lang=ts&"
import style0 from "./Game.vue?vue&type=style&index=0&id=de724fe2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de724fe2",
  null
  
)

export default component.exports